import styled from "styled-components";

export const Chip = styled.div`
  display: flex;
  color: white;
  margin-bottom: 7px;
`;

export const ChipTxt = styled.div`
  font-family: "Rubik";
  color: white;
  font-size: 12px;
  padding-left: 26px;
`;

export const Title = styled.div`
  font-family: "Rubik";
  color: white;
  font-size: 13px;
  padding-left: 10px;
  font-weight: bold;
`;

export const Card = styled.div`
  align-items: center;
  justify-content: center;
  padding: 0px 0px 25px 0px;
`;

export const CardContainer = styled.div`
  padding: 0px 0px 0px 0px;
`;

export const Container = styled.div`
  padding: 30px 30px 5px 30px;
`;
